import { Directive } from '@angular/core';
import { BaseComponent } from './base.component';
import { PopupsManagerService } from '../../services/popups-manager.service';

@Directive()
// tslint:disable-next-line:directive-class-suffix
export class BasePopupComponent extends BaseComponent {
  constructor(public popupsManagerService: PopupsManagerService) {
    super();
  }

  public closePopup(): void {
    this.popupsManagerService.hide();
  }
}
